/**
 * Pièces jointes aux articles de stock.
 *
 * Ces quelques règles vivent hors du composant : elles se vérifient seules, et
 * le composant n'a plus qu'à les appliquer.
 */

/** Taille maximale acceptée par le serveur, en octets. */
export const TAILLE_MAX_PIECE = 10 * 1024 * 1024;

/**
 * Exprime une taille en mégaoctets, à la suisse.
 *
 * @param {number} octets taille du fichier
 * @returns {string} la taille en mégaoctets, virgule décimale comprise
 */
export function enMo(octets) {
  return (octets / (1024 * 1024)).toFixed(1).replace('.', ',');
}

/**
 * Dit si un article existe côté serveur.
 *
 * Un article que l'on est en train de saisir ne porte qu'un numéro de
 * brouillon, attribué par l'écran : il n'y a encore rien à quoi accrocher un
 * fichier, et l'envoyer le perdrait.
 *
 * @param {number|string} id identifiant de l'article
 * @returns {boolean} vrai si l'article est enregistré
 */
export function estEnregistre(id) {
  return typeof id === 'number' && Number.isFinite(id) && id > 0;
}

/**
 * Sépare les photos des plans, dans l'ordre reçu.
 *
 * @param {object[]} [medias] pièces de l'article
 * @returns {{photos: object[], plans: object[]}} les deux familles
 */
export function separeLesPieces(medias) {
  const pieces = medias || [];
  return {
    photos: pieces.filter((m) => m && m.typePiece !== 'PLAN'),
    plans: pieces.filter((m) => m && m.typePiece === 'PLAN'),
  };
}
